// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__75mNl","inactive":"styles_inactive__GlcI+","active":"styles_active__yF8xz"};